<style>
.van-tabs--line .van-tabs__wrap{height: 50px}
</style>
<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="banner-box">
      <div class="banner-con">
        <div class="banner-title">轻骑兵<div style="font-size: 15px;vertical-align: super;line-height: 20px">®</div>低代码PaaS平台</div>
        <div class="banner-desc">创新驱动，共筑数字化未来！</div>
        <!-- 视频 -->
        <div class="banner-video-bg">
          <div class="banner-videoBox">
            <div class="banner-video" @click="startBannerVideo">
              <img
                src="../assets/img/homePage/banner-start.png"
                alt="播放"
                style="height: 35px"
              />
            </div>
          </div>
        </div>
        <!-- 数字 -->
        <div class="notice-nums">
          <img src="../assets/img/phoneHomePage/firstNums.png" alt="" />
        </div>
        <!-- 企业数字化建设的底座-->
        <div class="digitalize">
          <div class="digitalize-title">企业数字化建设的底座</div>
          <div class="digitalize-bg">
            <img src="../assets/img/phoneHomePage/digitalize-new.png" />
          </div>
        </div>
        <!-- 主要功能 -->
        <div class="main-method">
          <div class="main-title">六大核心功能</div>
          <van-tabs
            v-model="mainActive"
            animated
            swipeable
            duration="0.5"
            line-width="80px"
            line-height="2px"
            title-active-color="#186CF5"
            color="#186CF5"
            background="#F1F5FB"
            style="z-index: 5"
          >
            <van-tab title="低代码开发" name="first">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/function1.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>AI低代码、低代码开发、高安全性、信创支持、高扩展性、二次开发、微服务</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="零代码开发" name="second">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/lingdaima.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>私有化部署、零低融合、零转低、高扩展性、国产化适配、对接原系统</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="融合集成" name="third">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/ronghejicheng.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>可视化编排、服务持续集成、 信创要求、高安全性、深度运维监控</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="工作流平台" name="fourth">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/tongyiliucheng.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>架构灵活、多租户、功能丰富、灵活的配置体系、多渠道消息推送、国产化适配</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="统一门户" name="fourth">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/tongyimenhu.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>千人千面、信息中心、应用中心、统一权限、统一认证</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="智能中台" name="fourth">
              <div class="main-tabs-tabItem">
                <img src="../assets/img/homePage/img6.gif" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>智能化全生命周期管理、开放性、可扩展性、安全高效</div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
          <div class="btn" style="text-align: center;padding-bottom: 40px;">
            <img src="../assets/img/phoneHomePage/liaojiegengduo-button.png" @click="handleOpenPractice" style="width: 130px">
<!--            <img src="../assets/img/phoneHomePage/circular-blue.png"  style="width: 300px;position: absolute;right: -100px;bottom: -1600px;z-index: 0;">-->
          </div>
        </div>
        <!-- 核心价值 -->
        <div class="core-value">
          <div class="core-title">核心价值</div>
          <div class="core-layout">
            <div class="core-content">
              <div class="core-item">
                <div>
                  <span class="value-title">低/零代码平台，革新研发范式，实现降本增效</span>
                  <div class="value-desc">轻骑兵低/零代码开发平台助力企业优化研发流程，降低技术门槛，提升研发效率，在保证研发质量的同时缩短研发周期，实现企业的降本增效。</div>
                  <img src="../assets/img/phoneHomePage/core-item-1.png" />
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title">融合集成平台，消除信息孤岛，强化协同效能</span>
                  <div class="value-desc">轻骑兵融合集成平台凭借卓越的集成能力，实现跨系统、跨平台的数据整合。统一门户与流程的引入，消除信息壁垒，为企业的高效运作提供坚实支撑。</div>
                  <img src="../assets/img/phoneHomePage/core-item-2.png" />
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title">AI智能中台，智能驱动决策，促进数据融合</span>
                  <div class="value-desc">轻骑兵AI智能中台依托尖端智能分析与学习能力，为企业提供精准、高效的业务流程决策支持，助力企业实现由数字化向数智化的历史性跨越。</div>
                  <img src="../assets/img/phoneHomePage/core-item-3.png" />
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title" style="font-size: 13px">可靠PaaS底座，稳固数字化基石，保障国产化战略实施</span>
                  <div class="value-desc">轻骑兵低代码PaaS平台作为一个可靠、稳定的低代码PaaS平台，全面适配国产化环境，作为企业研发底座，为数字化转型之路提供了坚实的技术保障。</div>
                  <img src="../assets/img/phoneHomePage/core-item-4.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 更多产品特性-->
        <div class="expand">
          <div class="expand-title">产品特性</div>
          <div class="expand-layout">
            <div class="expand-content">
              <div>
                <img src="../assets/img/phoneHomePage/expand-6.png" />
                <div>
                  <span>AI智能</span>
                </div>
              </div>
              <div>
                <img src="../assets/img/phoneHomePage/expand-2.png" />
                <div>
                  <span>二次开发</span>
                </div>
              </div>
              <div>
                <img src="../assets/img/phoneHomePage/expand-3.png" />
                <div>
                  <span>高安全性</span>
                </div>
              </div>
              <div>
                <img src="../assets/img/phoneHomePage/expand-4.png" />
                <div>
                  <span>原型即应用</span>
                </div>
              </div>
              <div>
                <img src="../assets/img/phoneHomePage/expand-5.png" />
                <div>
                  <span>多租户</span>
                </div>
              </div>
            </div>
            <div class="expand-content">
              <div>
                <img src="../assets/img/phoneHomePage/expand-1.png" />
                <div>
                  <span>零/低/高开发</span>
                </div>
              </div>
              <div>
                <img src="../assets/img/phoneHomePage/expand-7.png" />
                <div>
                  <span>信创兼容</span>
                </div>
              </div>
              <div>
                <img src="../assets/img/phoneHomePage/expand-8.png" />
                <div>
                  <span>单体/微服务架构</span>
                </div>
              </div>
              <div>
                <img src="../assets/img/phoneHomePage/expand-9.png" />
                <div>
                  <span>组件丰富</span>
                </div>
              </div>
              <div>
                <img src="../assets/img/phoneHomePage/expand-10.png" />
                <div>
                  <span>模型/表单驱动</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 案例 -->
        <div class="case">
          <div class="case-title">案例</div>
          <div class="case-box">
            <van-swipe class="case-swipe" :width="300" :loop="false">
              <van-swipe-item>
                <div class="case-item">
                  <img
                    src="../assets/img/phoneHomePage/swipe-1.png"
                    style="width: 100%"
                  />
                  <div class="title">华中科技公司 余主任</div>
                  <div class="text">
                    轻骑兵低代码开发平台统一了公司的技术架构，完善了公司的研发体系，该平台的可视化设计器支持定制各种自定义组件，赋能公司设计团队，助力公司技术积累。
                  </div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="case-item">
                  <img src="../assets/img/phoneHomePage/swipe-2.png" />
                  <div class="title">航天科工集团某研究所 李总</div>
                  <div class="text">
                    轻骑兵的可视化设计器很好用，基于平台可以快速进行可视化开发，提升我们的研发效率，平台符合分保要求，支持多版本兼容，这对我们而言是非常重要的两点。
                  </div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="case-item">
                  <img src="../assets/img/phoneHomePage/swipe-3.png" />
                  <div class="title">联通河北分公司 赵经理</div>
                  <div class="text">
                    轻骑兵低代码开发平台，对业务场景具备快速实现能力，可视化开发模式降低了应用软件的开发难度，开发效率大幅提升。在客户项目中，平台能够快速友好的同其他系统进行整合，实现数据双向交换、共享业务处理流程，同时也减轻了软件维护的负担。
                  </div>
                </div>
              </van-swipe-item>
              <van-swipe-item>
                <div class="case-item">
                  <img src="../assets/img/phoneHomePage/swipe-4.png" />
                  <div class="title">玫德集团 生经理</div>
                  <div class="text">
                    轻骑兵低代码开发平台显著降低了企业开发人员数量和水平的要求，能够快速响应客户需求，灵活应用在复杂的开发场景中，降低开发人员的工作量，大幅提高编码效率。
                  </div>
                </div>
              </van-swipe-item>
<!--              <van-swipe-item>-->
<!--                <div class="case-item">-->
<!--                  <img src="../assets/img/phoneHomePage/swipe-5.png" />-->
<!--                  <div class="title">临沂城投思索 丁经理</div>-->
<!--                  <div class="text">-->
<!--                    轻骑兵低代码开发平台具有可视化低代码开发、开发组件丰富、高安全性等特性，全面适配了国产化环境。我公司采用轻骑兵低代码开发平台大大提升了软件系统开发速度和质量，对降低软件开发成本效果显著。-->
<!--                  </div>-->
<!--                </div>-->
<!--              </van-swipe-item>-->
              <van-swipe-item>
                <div class="case-item">
                  <img src="../assets/img/phoneHomePage/swipe-6.png" />
                  <div class="title">中泰证券 梁经理</div>
                  <div class="text">
                    轻骑兵低代码开发平台统一了后续公司平台的技术框架，各部门的开发成果以组件的形式得到了积累复用，提高了开发效率，极大的减少了不同系统中互联互通的成本，避免了资源的浪费。
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="case-application-box">
            <div class="case-application">
              <div class="title">应用行业</div>
              <van-divider :style="{ borderColor: '#FFFFFF' }" />
              <div class="case-application-items">
                <div class="case-application-item">
                  <div>电力能源</div>
                  <div>智能制造</div>
                  <div>工程建筑</div>
                </div>
                <div class="case-application-item">
                  <div>轨道交通</div>
                  <div>冶金冶炼</div>
                  <div>政务服务</div>
                </div>
                <div class="case-application-item">
                  <div>航天军工</div>
                  <div>证券金融</div>
                  <div>产教融合</div>
                </div>
                <div class="case-application-item">
                  <div>石油石化</div>
                  <div>移动通信</div>
                  <div>商业服务</div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn">
            <img src="../assets/img/phoneHomePage/liaojiegengduo-button.png" @click="handleOpenPractice" style="width: 130px">
          </div>
        </div>
        <!-- 资质荣誉-->
        <div class="honor">
          <div class="honor-title">资质荣誉</div>
<!--          <img src="../assets/img/phoneHomePage/honor.png" class="honorItem" alt=""/>-->
          <div class="honor-table">
            <div>
              <img src="../assets/img/phoneHomePage/arrow-up-blue.png"><span> 第一个</span>
              <p>低代码国家标准</p>
            </div>
            <div>
              <img src="../assets/img/phoneHomePage/arrow-up-blue.png"><span> 50+</span>
              <p>发明专利</p>
            </div>
            <div>
              <img src="../assets/img/phoneHomePage/arrow-up-blue.png"><span> 30+</span>
              <p>新创认证</p>
            </div>
            <div>
              <img src="../assets/img/phoneHomePage/arrow-up-blue.png"><span> 300+</span>
              <p>奖项</p>
            </div>
          </div>
          <p>工信部“鼎信杯”信息技术应用创新优秀应用产品奖</p>
          <p>工信部信息技术应用创新工作委员会产品库入库产品</p>
          <p>工信部工业互联网APP优秀解决方案</p>
          <p>山东省重点研发计划（重大科技创新工程）项目</p>
          <p>“鲲鹏杯”山东新动能-软件创新创业大赛 企业组特等奖</p>
          <p>中国软件行业协会年度优秀软件产品</p>
          <p>中国行业信息化最佳产品</p>
          <p>中国软件技术最佳产品奖</p>
          <p>中国低代码年度明星产品奖</p>
          <p>山东省软件产业高质量发展重点项目</p>
          <img
            class="honorImg"
            src="../assets/img/phoneHomePage/honor-img.png"
          />
        </div>
        <!-- 底部公司信息 -->
        <CompanyInformation
          @changePracticeMenuShow="handleOpenPractice"
        ></CompanyInformation>
      </div>
      <!-- 右侧菜单 -->
      <RightMenu
        :isMenuShow="isMenuShow"
        @rightMenuShow="handleRightMenuShow"
      ></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow
        :isPopShow="isPopShow"
        @CloseExperienceNow="handleCloseExperienceNow"
      ></ExperienceNow>
      <!-- 视频弹窗 -->
      <el-dialog
        v-show="videoPlayDialogVisible"
        :visible.sync="videoPlayDialogVisible"
        width="100%"
        class="video-dialog"
        @close="closeVideoPlayDialog"
      >
        <video
          style="width: 100%"
          src="../assets/video/qqbxc.mp4"
          ref="video"
          controls
          playsinline
          webkit-playsinline
          autoplay
        ></video>
      </el-dialog>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import Swiper, { Navigation } from "swiper";
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import CompanyInformation from "./include/CompanyInformation";
import ExperienceNow from "./include/ExperienceNow";
const function21 = require("../assets/img/homePage/function21.gif");
const function22 = require("../assets/img/homePage/function22.gif");
Swiper.use([Navigation]);
export default {
  name: "HussarHomePhonePage",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      videoPlayDialogVisible: false, // 顶部视频播放弹窗
      modelActive: "formular", // tab页默认显示
      mainActive: "first", // tab页默认显示
      funcSrc: "function21", // 动图播放完毕后显示gif
      // formular: require("@/assets/img/phoneHomePage/model-1.gif"),
      // frontCode: require("@/assets/img/phoneHomePage/model-2.gif"),
      // external: require("@/assets/img/phoneHomePage/model-3.gif"),
      // codeAnalysis: require("@/assets/img/phoneHomePage/model-4.gif"),
    };
  },
  watch: {
    mainActive(n) {
      if (n === "second") {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 3000);
      }
    },
  },
  methods: {
    // 打开视频并播放
    startBannerVideo() {
      const self = this;
      self.videoPlayDialogVisible = true;
      self.$nextTick(() => {
        self.$refs.video.play();
      });
    },
    // 关闭视频弹窗暂停视频播放
    closeVideoPlayDialog() {
      const self = this;
      self.$nextTick(() => {
        self.$refs.video.pause();
      });
    },
    // 了解更多
    handleRouter() {
      this.$router.push("/CasePhonePage");
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 视频 */
.banner-box {
  width: 100%;
  height: 391px;
  background: url("../assets/img/phoneHomePage/banner-bg.png");
  background-size: cover;
}

.banner-con {
  width: 100%;
  margin: 0 auto;
  padding-top: 100px;
}

.banner-title {
  font-size: 24px;
  font-weight: bold;
  line-height: 50px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.banner-desc {
  display: flex;
  align-items: center;
  position: relative;
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  justify-content: center;
}

.banner-video-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.banner-videoBox {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  width: 310px;
  height: 180px;
}

.banner-video {
  justify-content: center;
  background: url("../assets/img/phoneHomePage/video-bg2.png") no-repeat;
  background-size: 100%;
  transform: 100%;
  text-align: center;
  width: 300px;
  height: 170px;
  background-color: #ccc;
}

.banner-video > img {
  margin-top: 65px;
}

/* 数字 */
.notice-nums {
  display: flex;
  justify-content: space-around;
  height: 220px;
  padding-top: 10px;
  width: calc(100%);
}

.notice-nums > img {
  background-size: cover;
  width: 100%;
}

/* 企业数字化转型的底座 */
.digitalize {
  width: 100%;
}

.digitalize > img {
  width: 100%;
  margin-top: 20px;
}

.digitalize-title {
  font-size: 25px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  padding-top: 48px;
  padding-bottom: 25px;
}

.digitalize-bg {
  text-align: center;
  padding: 0 18px;
}

.digitalize-bg > img {
  width: 100%;
  margin-bottom: 50px;
}

/* 平台具备很强的扩展性 */
.model-title {
  font-size: 29px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  padding-top: 40px;
  margin-bottom: 15px;
}

/* 主要功能 */
.main-method {
  background: url("../assets/img/phoneHomePage/mainmethod-bg.png");
  overflow: hidden;
}

.main-title {
  font-size: 25px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  padding: 44px 0 24px 0;
}

.main-tabs-tabItem {
  display: flex;
  margin: 20px 0 32px 0;
  justify-content: center;
}

.main-tabs-tabItem > img {
  height: 200px;
}

.main-tabs-tabItem-box {
  display: flex;
  justify-content: center;
  height: 100%;
  min-height: 100px;
}

.main-tabs-tabItem-box > div {
  width: 90%;
}

.main-tabs-tabItem-context-item {
  display: flex;
  margin-bottom: 10px;
}

.main-tabs-tabItem-context-item > img {
  height: 20px;
  padding-right: 10px;
}

.main-tabs-tabItem-context-item > div {
  font-size: 15px;
  line-height: 30px;
}

/* 核心价值 */
.core-value {
  background: #FFFFFF;
}

.core-title {
  font-size: 25px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  padding: 40px 0 30px 0;
}

.core-layout {
  display: flex;
  padding-bottom: 30px;
}

.core-content {
  width: 90%;
  margin: auto;
  color: #FFFFFF;
}

.value-title {
  font-size: 14px;
  font-weight: bold;
}

.value-desc {
  font-size: 12px;
  margin-top: 10px;
  line-height: 20px;
  color: #EEEEEE;
}

.core-item {
  background: #3273F3;
  height: 150px;
  background-size: 100% 80px;
  margin-bottom: 20px;
  display: flex;
  padding: 15px 8px;
  border-radius: 5px;
}
.core-item img{
  width: 55px;
  position: relative;
  left: 280px;
  top: -20px;
}

/* 更多产品特性 */
.expand {
  padding: 20px 0 50px 0;
}

.expand-title {
  font-size: 25px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  padding-top: 20px;
}

.expand-layout {
  display: flex;
  text-align: center;
  justify-content: center;
  margin-top: 30px;
}

.expand-content {
  width: 45%;
}

.expand-content > div {
  display: flex;
  padding: 15px 8px;
  background-color: #f8faff;
  margin: 10px 5px;
}

.expand-content > div > img {
  height: 20px;
  margin-left: 3px;
  margin-right: 6px;
}

.expand-content > div > div > span {
  font-size: 14px;
  line-height: 20px;
}

/* 案例 */
.case {
  background: url("../assets/img/phoneHomePage/case-bg.png");
  height: 828px;
}

.case-title {
  font-size: 25px;
  font-weight: bold;
  line-height: 56px;
  text-align: center;
  padding: 30px 0;
  color: white;
}

.case-box {
  display: flex;
  justify-content: center;
}

.case-swipe {
  height: 350px;
}

.case-swipe >>> .van-swipe__indicators .van-swipe__indicator {
  background: #333333;
}

.case-swipe >>> .van-swipe__indicator--active {
  background-color: #1989fa !important;
}

.case-item {
  height: 100%;
  width: 90%;
  padding: 20px 20px 0 20px;
  background-image: linear-gradient(to bottom, #fff, #e9f0ff);
  border-radius: 5px;
}

.van-swipe-item {
  display: flex;
  justify-content: center;
}

.case-item > img {
  height: 55px;
}

.case-item > .title {
  margin: 10px 0;
  font-size: 18px;
  font-weight: 600;
}

.case-item > .text {
  font-size: 15px;
  font-weight: 400;
  line-height: 25px;
}

.case-application-box {
  display: flex;
  justify-content: center;
}

.case-application {
  width: 90%;
  height: 200px;
  padding: 20px;
  background: #203558;
  margin-top: 40px;
}

.case-application .title {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.case-application-items {
  display: flex;
  justify-content: space-between;
}

.case-application-item > div {
  font-size: 15px;
  color: #fff;
  margin-bottom: 15px;
}

.case > .btn {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

/* 资质荣誉 */
.honor {
  padding-top: 20px;
  background: url("../assets/img/phoneHomePage/honor-bg.png");
  padding-bottom: 50px;
  width: 100%;
}
.honor-table{
  width: 90%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  background: #ffffff;
  margin: 20px auto;
}
.honor-table > div{
  width: 100%;
  border: 1px solid #EEEEEE;
  height: 80px;
  padding: 15px 0px 0px 35px;;
}
.honor-table img{
  height: 20px;
  margin-bottom: -3px;
}
.honor-table span{
  font-size: 20px;
  font-weight: bold;
 }
.honor-table p{
  margin-top: 3px;
  font-size: 13px;
}
.honor > p{
  text-align: center;
  line-height: 25px;
}
.honor > .honorItem {
  width: 100%;
}

.honor > .honorImg {
  margin-top: 25px;
  width: 100%;
}

.honor-title {
  font-size: 25px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 15px;
}

/* 主页视频弹窗 */
.video-dialog {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.video-dialog /deep/ .el-dialog__header {
  padding: 0;
}
.video-dialog /deep/ .el-dialog__body {
  padding: 0;
  height: 210px;
}
.video-dialog /deep/ .el-dialog__headerbtn {
  font-size: 24px;
  z-index: 1;
}
.video-dialog /deep/ .el-dialog {
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: -200px;
}
/* 视频弹窗end */
</style>



// WEBPACK FOOTER //
// src/components/HussarHomePhonePage.vue